import React, { useState, useEffect, useRef } from "react";
import Modal from "react-bootstrap/Modal";
import {
  GetCircle,
  GetZone,
  CreateCircleDeatails,
  UpdateCircleDetails,
  // getCircleById,
} from "../../Apis/organizationApi";
import TableComponent from "../../Common/TableComponent/tableComponent";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Loader from "../../Common/Loader/loader";
import { withTranslation } from "react-i18next";
import * as XLSX from "xlsx"; // Import XLSX library for Excel operations
import ExcelJS from "exceljs";
const OrganizationCircle = ({ t }) => {
  const [lgShow, setLgShow] = useState(false);
  const [circles, setCircles] = useState([]);
  const [zones, setZones] = useState([]);
  const [allZones, setAllZones] = useState([]);
  //const [status, setStatus] = useState("")
  const [editCircleData, setEditCircleData] = useState("");
  const [isOptionsLoading, setIsOptionsLoading] = useState(true);
  const [orginalCircles, setOriginalCircle] = useState([]);
  const [formSubmitted, setFormSubmitted] = useState(false);
  const [sortConfig, setSortConfig] = useState(null);
  const [originalData, setOriginalData] = useState([]);
  const [sortedData, setSortedData] = useState([]); // New state to store sorted data
  const [excelData, setExcelData] = useState([]);
  const [filterOriginalCircleData, setFilterOriginalCircleData] = useState([]);
  const hasFetchedData = useRef(false);
  let storedPermissions = localStorage.getItem('permissionId')
  const permissionValues1 = JSON.parse(localStorage.getItem('rolePermissions')) || {};
  let canWriteValue = null;

  // Convert storedPermissions to a number (if needed)
  storedPermissions = parseInt(storedPermissions, 10);

  // Find the matching roleToPermissionMapping object
  const matchingPermission = permissionValues1.find(mapping => mapping.permissionId === storedPermissions);

  if (matchingPermission) {
    canWriteValue = matchingPermission.canWrite;
    console.log(`canWrite value for permission ID ${storedPermissions}:`, canWriteValue);
  } else {
    console.log(`No match found for permission ID ${storedPermissions}`);
  }

  const [formInput, setFormInput] = useState({
    zoneId: "",
    circleCode: "",
    circleName: "",
    isActive: true
  });
  const headers = ["zone", "circle", "circleCode", "status", "actions"];
  const handleClose = () => {
    setLgShow(false);
    setFormSubmitted(false);
    setEditCircleData("");
    setFormInput({
      zoneId: "",
      circleCode: "",
      circleName: "",
      isActive: "",
    });
  };
  useEffect(() => {
    if (!hasFetchedData.current) {
      hasFetchedData.current = true;
      fetchData();
    }
  }, []);

  useEffect(() => {
    // Combine sortedData with excelData
    setExcelData(sortedData);
  }, [sortedData]);
  const fetchData = async () => {
    try {
      const zoneData = await GetZone();
      const circleData = await GetCircle();

      // Create a dictionary of Zone IDs and Zone Names
      const zoneNamesDictionary = {};
      zoneData.forEach(zone => {
        zoneNamesDictionary[zone.zoneId] = zone.zoneName;
      });

      // Map Zone Names to Circles
      const translatedData = circleData.map(circle => ({
        ...circle,
        zone: zoneNamesDictionary[circle.zoneId] || "Unknown",
        circle: `${circle.circleName}`,
        status: circle.isActive ? "Active" : "InActive"
      }));

      setCircles(translatedData);
      setOriginalCircle(circleData);
      setOriginalData(translatedData);
      setFilterOriginalCircleData(translatedData);
      // Sort the data based on the isActive field
      const sortedCircleData = translatedData.sort((a, b) => {
        if (a.isActive === b.isActive) {
          return 0;
        }
        return a.isActive ? -1 : 1;
      });
      setOriginalCircle(sortedCircleData);

      // Store all zones for mapping purposes
      setAllZones(zoneData);
      // getting zone dropsown active only
      const trueValues = zoneData.filter(item => item.isActive === true)
      setZones(trueValues);
      // setZones(zoneData);
      setIsOptionsLoading(false);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const fetchCircleDataOnly = async () => {
    try {
      const circleData = await GetCircle();

      // Use all zones from state to create zone names dictionary
      const zoneNamesDictionary = {};
      allZones.forEach(zone => {
        zoneNamesDictionary[zone.zoneId] = zone.zoneName;
      });

      // Map Zone Names to Circles
      const translatedData = circleData.map(circle => ({
        ...circle,
        zone: zoneNamesDictionary[circle.zoneId] || "Unknown",
        circle: `${circle.circleName}`,
        status: circle.isActive ? "Active" : "InActive"
      }));

      setCircles(translatedData);
      setOriginalCircle(circleData);
      setOriginalData(translatedData);
      setFilterOriginalCircleData(translatedData);
      // Sort the data based on the isActive field
      const sortedCircleData = translatedData.sort((a, b) => {
        if (a.isActive === b.isActive) {
          return 0;
        }
        return a.isActive ? -1 : 1;
      });
      setOriginalCircle(sortedCircleData);
    } catch (error) {
      console.error("Error fetching circle data:", error);
    }
  };

  // useEffect(() => {
  //   console.log(formInput.isActive, "forminput to ");
  // }, [formInput.isActive]);



  const handleInputChange = (e) => {
    const { name, value } = e.target;
    const formattedValue = value
    .slice(0, 42) // Limit to 42 characters
    .replace(/^\s+/, "") // Remove leading spaces
    .replace(/\s{2,}/g, " ") // Replace multiple spaces with a single space
    .replace(/[^A-Za-z0-9\s-]/g, ""); // Allow only letters, numbers, spaces, and hyphens

  setFormInput({ ...formInput, [name]: formattedValue });
  };
  const handleCodeChange = (e) => {
    const { name, value } = e.target;
    const formattedValue = value
    .slice(0, 42) // Limit to 42 characters
    .replace(/^\s+/, "") // Remove leading spaces
    .replace(/\s{2,}/g, " ") // Replace multiple spaces with a single space
    .replace(/[^A-Za-z0-9\s-]/g, ""); // Allow only letters, numbers, spaces, and hyphens

  setFormInput({ ...formInput, [name]: formattedValue });
  }
  const handleStatusChange = (e) => {
    const { name, value } = e.target;
    setFormInput((prevData) => ({
      ...prevData,
      // [name]: value === "true" ? true : false,
      [name]: value === "true",
    }));
  };

  const handleCreateCircle = async (e) => {
    e.preventDefault();
    setFormSubmitted(true);
    try {
      setIsOptionsLoading(true);

      // if (!formInput.zoneId || !formInput.circleName || !formInput.circleCode) {
      //   toast.error("Please fill out all required fields");
      //   return;
      // }
      if (!formInput.zoneId || !formInput.circleName ) {
        // Display error messages next to the fields
        if (!formInput.zoneId) {
          document.getElementById('zoneIdError').innerText = 'Zone is Required';
        }
        if (!formInput.circleName) {
          document.getElementById('circleNameError').innerText = 'Circle is Required.';
        }

        return;
      }
      // const isActive = formInput.isActive === "true";
      // console.log("isActive:", isActive); // Log isActive value
      const isDuplicateCode = circles.some(
        (type) =>
          type.circleCode === formInput.circleCode &&
          type.circleName !== editCircleData?.circleName && // Exclude the current edited vehicle capacity if any
          type.zoneId !== editCircleData?.zoneId
      );

      if (isDuplicateCode) {
        // If duplicate code found, show error toast and return
        toast.error("Circle Code already exists. Please choose a different one.", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
        });
        return;
      }
      const { zoneId, circleName, circleCode, isActive } = formInput;
      const circleData = {
        // zoneId: formInput.zoneId,
        // circleName: formInput.circleName,
        // circleCode: formInput.circleCode,
        // // isActive: isActive,
        zoneId, circleName, circleCode, isActive
      };

      if (editCircleData) {
        circleData.circleId = editCircleData.circleId;
      }
      if (!zones || !circles) {
        toast.error("Zone,Circle& wardName are required");
        return;
      }
      circleData.circleName = circleData.circleName.replace(/\s*\[.*?\]\s*$/, '');

      const response = editCircleData ? await UpdateCircleDetails(circleData) : await CreateCircleDeatails(circleData);

      if (editCircleData) {
        toast.success('Circle updated Successfully!');
      } else {
        toast.success('Circle added Successfully!');
      }

      fetchCircleDataOnly();
      handleClose();
    } catch (error) {
      if (error.response) {
        const { status, data } = error.response;
        if (status === 409) {
          // Handle 409 status code errors
          const errorMessage = data;
          toast.error(errorMessage, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
          });
        } else if (status === 400) {
          // Handle 409 status code errors
          const errorMessage = data;
          toast.error(errorMessage, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
          });
        }
      }
    } finally {
      setIsOptionsLoading(false);
    }
  };

  useEffect(() => {
    setFormInput(
      editCircleData || {
        circleId: "",
        circleName: "",
        circleCode: "",
        zoneId: "",
        isActive: true,
      }
    );
  }, [editCircleData]);

  const handleShow = () => {
    setLgShow(true);
    setIsOptionsLoading(true);
    setTimeout(() => {
      setIsOptionsLoading(false);
    }, 1000);
    setEditCircleData(null);
    if (zones.length > 0) {
      setFormInput({
        circleId: "",
        zoneId: zones[0].zoneId, // Set to the first available zone's id
        circleCode: "",
        circleName: "",
        isActive: true,
      });
    } else {
      // If there are no zones available, set zoneId to an empty string
      setFormInput({
        circleId: "",
        zoneId: "",
        circleCode: "",
        circleName: "",
        isActive: true,
      });
    }
  };

  // const handleEditCircle = (selectedCircle) => {
  //   setEditCircleData(selectedCircle);
  //   console.log("Edit ", selectedCircle);
  //   setLgShow(true);
  //   setIsOptionsLoading(true);
  //   setTimeout(() => {
  //     setIsOptionsLoading(false);
  //   }, 1000);
  //   setFormInput({
  //     zoneId: selectedCircle?.zoneId,
  //     circleCode: selectedCircle?.circleCode,
  //     circleName: selectedCircle?.circleName,
  //   });
  // };

  const handleEditCircle = (selectedCircle) => {
    selectedCircle.circleName = selectedCircle.circleName.replace(
      /\s*\[[^\]]*]/,
      ""
    );
    setEditCircleData(selectedCircle);
    setLgShow(true);
    setIsOptionsLoading(true);
    setTimeout(() => {
      setIsOptionsLoading(false);
    }, 1000);
    setFormInput({
      circleId: selectedCircle?.circleId,
      zoneId: selectedCircle?.zoneId,
      circleCode: selectedCircle?.circleCode,
      circleName: selectedCircle?.circleName,
      isActive: selectedCircle?.isActive,
    });
  };


  const options = { day: 'numeric', month: 'numeric', year: 'numeric' };
  const generationTime = ` ${new Date().toLocaleString('en-GB', options).replace(/\//g, '/')}`;
  const downloadAsExcel = async () => {
    // Create a new workbook and add a worksheet
    const dataToUse = sortedData.length > 0 ? sortedData : originalData;
    const currentDate = new Date();
    const formattedDate = `${currentDate.getFullYear()}-${currentDate.getMonth() + 1
      }-${currentDate.getDate()}`;
    const formattedTime = `${currentDate.getHours()}:${currentDate.getMinutes()}:${currentDate.getSeconds()}`;
    const downloadDateTime = `Circle Report Generated on: ${generationTime},${formattedTime}`;
    // Calculate the length of the downloadDateTime string
    const downloadDateTimeLength = downloadDateTime.length;
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("Circles");

    // Define styles
    const boldFont = { bold: true };

    // Add the downloadDateTime to the correct row and columns, and ensure formatting
    worksheet.addRow(["", "", downloadDateTime, ""]); // Update array length to match new cell range
    worksheet.mergeCells(1, 2, 1, 5); // Merge cells for downloadDateTime from column 2 to 4
    worksheet.getCell(1, 2).value = downloadDateTime; // Ensure the value is set after merging
    worksheet.getCell(1, 2).font = boldFont; // Set font style
    worksheet.getCell(1, 2).alignment = { horizontal: "center" }; // Center align the content

    // Apply styles to the merged cells (B1, C1, D1)
    for (let col = 2; col <= 5; col++) {
      worksheet.getCell(1, col).font = boldFont; // Set styles individually
      worksheet.getCell(1, col).alignment = { horizontal: "center" }; // Center align the cell content
    }

    // Add "Zone Details" to the correct row and columns, and ensure formatting
    worksheet.addRow(["", "", "Circle Details", ""]); // Update array length to match new cell range
    worksheet.mergeCells(2, 2, 2, 5); // Merge cells for Zone Details from column 2 to 4
    worksheet.getCell(2, 2).value = "Circle Details"; // Ensure the value is set after merging
    worksheet.getCell(2, 2).font = boldFont; // Set font style
    worksheet.getCell(2, 2).alignment = { horizontal: "center" }; // Center align the content

    // Apply styles to the merged cells (B2, C2, D2)
    for (let col = 2; col <= 5; col++) {
      worksheet.getCell(2, col).font = boldFont; // Set styles individually
      worksheet.getCell(2, col).alignment = { horizontal: "center" }; // Center align the cell content
    }




    // worksheet.addRow(["", "", "", "", downloadDateTime, "", "", "", ""]);
    // worksheet.mergeCells(2, 5, 2, 8); // Merge cells for downloadDateTime
    // for (let col = 5; col <= 8; col++) {
    //   worksheet.getCell(2, col).font = boldFont; // Set styles individually
    //   worksheet.getCell(2, col).alignment = { horizontal: "center" }; // Center align the cell content
    // }

    // Add table header row with bold font
    const tableHeaderRow = worksheet.addRow([
      "S.No",
      "Zone",
      "Circle",
      "Circle Code",
      "Status",
    ]);
    tableHeaderRow.eachCell({ includeEmpty: true }, (cell, colNumber) => {
      cell.font = boldFont;
      cell.alignment = { horizontal: "left", color: "#fff" }; // Center align the cell content
      if (colNumber >= 1 && colNumber <= 5) {
        // Apply background color and set text color
        cell.fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "F6B1B1" }, // Red background color
          bgColor: { argb: "FFFFFFFF" } // White text color
        };
      }
    });

    // Add data rows
    dataToUse.forEach((item, index) => {

      worksheet
        .addRow([
          index + 1,
          item.zone,
          item.circleName,
          item.circleCode,
          item.isActive ? 'Active' : 'InActive',

        ])
        .eachCell({ includeEmpty: true }, (cell, colNumber) => {
          if (colNumber >= 1 && colNumber <= 5) {
            // Align the columns from 1 to 4 to the left
            cell.alignment = { horizontal: "left" };
          } else {
            // Align the rest of the columns to the center
            cell.alignment = { horizontal: "center" };
          }
        });
    });

    // Add total row with bold font


    // Set column widths dynamically based on content
    worksheet.columns = [
      { width: 5 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 15 },
      { width: 15 },
      { width: 15 },
      { width: 40 },
    ];

    // Save the workbook to a file
    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = "CircleDetails.xlsx";
    a.click();
    URL.revokeObjectURL(url);
  };
  const handleSort = (sortConfig) => {
    // Assuming you have a method to sort data based on sortConfig
    const sorted = [...circles].sort((a, b) => {
      if (sortConfig.order === 'asc') {
        return a[sortConfig.column] > b[sortConfig.column] ? 1 : -1;
      } else {
        return a[sortConfig.column] < b[sortConfig.column] ? 1 : -1;
      }
    });

    setSortedData(sorted); // Update the sorted data
  };
  const handleSortAndExport = async () => {
    if (sortConfig) {
      handleSort(sortConfig); // Apply sorting
      await new Promise((resolve) => setTimeout(resolve, 100)); // Wait for state update
    }
    const dataToExport = sortConfig ? sortedData : originalData; // Use sorted or original data
    downloadAsExcel(dataToExport); // Export the data
  };
  const searchCircleHandler = (e) => {
    const term = e.target.value.toLowerCase();    
    const data = filterOriginalCircleData.filter(item => item?.circleName?.toLowerCase()?.includes(term) || item?.circleCode?.toLowerCase()?.includes(term))
    setCircles(data);
  }
  return (
    <>
      {/* <Body/> */}
      <div style={{ width: "100%" }}>
        <div className="content">
          <div className="page-content">
            <div className="page-header">
              <div className="row justify-content-between">
                <div className="col-md-3">
                  <div className="form-group">
                    <input
                      placeholder="Search Circle or Circle Code"
                      type="text"
                      className="form-control bg-white"
                      onInput={searchCircleHandler}
                    />
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="flex_end_middle mb-3">
                    {canWriteValue === true ?
                      <button className="button-container" onClick={handleShow}>
                        <i className="fa-solid fa-plus me-1 icon-container"></i>
                        {t("addCircle")}
                      </button>
                      : ''}
                    <button className="btn btn-excel"
                      onClick={handleSortAndExport}>
                      <i class="fa-solid fa-file-excel me-1 icon-container"></i> Excel
                    </button>
                  </div>
                </div>
              </div>
              <div className="card">
                <div className="card-body">
                  <div className="top-header">
                    <span>{t("circleDetails")}</span>
                  </div>

                  <TableComponent
                    DataFetchURL={circles}
                    headers={headers}
                    filterFunction={(data) =>
                      data.filter(
                        (item) => item.status === 1 || item.status === 2
                      )
                    }
                    editData={handleEditCircle}
                    editCircleData={editCircleData}
                    //viewData={(id) => handleViewCircleData(id)}
                    onSort={handleSort}
                    skipGetCircle={true}
                  />
                  {/* ) : (
                        <div>No data found</div>
                      )
                    )} */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {isOptionsLoading && <Loader />}
      <Modal
        size="md"
        show={lgShow}
        onHide={() => setLgShow(false)}
        aria-labelledby="example-modal-sizes-title-lg"
        backdrop="static"
      >
        <Modal.Header>
          <Modal.Title id="example-modal-sizes-title-lg">
            {editCircleData ? t("editCircle") : t("addCircle")}
          </Modal.Title>
          <i
            class="fa-solid fa-xmark close-container"
            onClick={handleClose}
          ></i>
        </Modal.Header>
        <hr />
        <Modal.Body>
          <form>
            <div className="row">
              <div className="col-md-6 mb-2">
                <div className="form-group">
                  <label className="form-label">
                    Select Zone {" "}
                    <span style={{ color: "#EC1117" }}> *</span>
                  </label>
                  <select
                    className={`form-select ${formInput.zoneId || !formSubmitted ? "" : "input-error"
                      }`}
                    // value={selectedZone ? selectedZone.zone_id : ""}
                    value={formInput.zoneId}
                    name="zoneId"
                    onChange={(e) => {
                      const zoneId = e.target.value;
                      setFormInput((prevData) => ({
                        ...prevData,
                        zoneId: zoneId,
                      }));
                    }}
                    disabled={!canWriteValue}
                  >
                    <option value="">Select</option>
                    {zones?.map((zone) => (
                      <option key={zone.zoneId} value={zone.zoneId}>
                        {zone.zoneName}
                      </option>
                    ))}
                  </select>
                  {!formInput.zoneId && formSubmitted && (
                    <div className="required-message">
                      Zone is Required
                    </div>
                  )}
                </div>
              </div>
              {/* <div className="col-md-4 mb-3">
                <div className="form-group">
                  <label className="form-label"> Circle Code <span style={{ color: '#EC1117' }}> *</span></label>
                  <input
                    type="text"
                    className={`form-control ${formInput.circleCode || !formSubmitted ? "" : "input-error"
                      }`}
                    value={formInput.circleCode}
                    name="circleCode"
                    placeholder="Enter Circle Code"
                    onChange={handleCodeChange}
                    maxLength={8}
                    disabled={!canWriteValue}
                  />
                  {!formInput.circleCode && formSubmitted && (
                    <div className="required-message">
                      Circle code Required
                    </div>
                  )}
                </div>
              </div> */}

              <div className="col-md-6 mb-3">
                <div className="form-group">
                  <label className="form-label">
                    Circle
                    <span style={{ color: "#EC1117" }}> *</span>
                  </label>
                  <input
                    type="text"
                    className={`form-control ${formInput.circleName || !formSubmitted ? "" : "input-error"
                      }`}
                    value={formInput.circleName}
                    placeholder="Enter Circle"
                    name="circleName"
                    onChange={handleInputChange}
                    maxLength={42}
                    disabled={!canWriteValue}
                  />
                  {!formInput.circleName && formSubmitted && (
                    <div className="required-message">
                      Circle is Required
                    </div>
                  )}
                </div>
              </div>
            </div>
            {/* {editCircleData && ( */}
            <div className="col-md-4">
              <label className="form-label">Status<span style={{ color: '#EC1117' }}> *</span></label>
              <div className="form-group" style={{ display: "flex" }}>
                <div className="form-check">
                  <input
                    type="radio"
                    className="form-check-input"
                    name="isActive"
                    id="activeRadio"
                    value="true"
                    checked={formInput.isActive === true} // Check if isActive is true
                    onChange={handleStatusChange}
                    disabled={!canWriteValue}
                  // onChange={() =>
                  //   handleInputChange({
                  //     target: { name: "isActive", value: true }, // Pass true when checked
                  //   })
                  // }
                  />
                  <label className="form-check-label" htmlFor="activeRadio">
                    Active
                  </label>
                </div>
                <div className="form-check" style={{ marginLeft: "40px" }}>
                  <input
                    type="radio"
                    className="form-check-input"
                    name="isActive"
                    value="false"
                    id="inactiveRadio"
                    checked={formInput.isActive === false}
                    // onChange={() =>
                    //   handleInputChange({
                    //     target: { name: "isActive", value: false }, // Set value to false
                    //   })
                    // }
                    onChange={handleStatusChange}
                    disabled={!canWriteValue}
                  />

                  <label className="form-check-label" htmlFor="inactiveRadio">
                    InActive
                  </label>
                </div>
              </div>
            </div>
            {/* )} */}
            <div className="modal-footer d-flex justify-content-center">
              {canWriteValue === true ?
                <button
                  type="button"
                  className="deployment-button"
                  onClick={handleCreateCircle}

                >
                  <i class="fa-solid fa-check done-container"></i>
                  {editCircleData ? t("Update") : t("Save")}
                </button>
                : ''}
            </div>
          </form>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default withTranslation()(OrganizationCircle);